import {
    DATA_SHIP_DEMOLITION_LIST_GET,
    DATA_SHIP_DEMOLITION_LIST_GET_F,
    DATA_SHIP_DEMOLITION_LIST_GET_R,
    DATA_SHIP_DEMOLITION_SELECTED_SET,
} from '../actionType';
const initialState = {
    dataLasticDemolition: [],
    isLoading: false,
    error: null,
    totalPage: 0,
    totalElement: 0,
    dataLasticSelectedDemolition: null,
}
export default function dataShipReducer(state = initialState, action: any) {
    switch (action.type) {
        case DATA_SHIP_DEMOLITION_LIST_GET:
            return {
                ...state,
                isLoading: true,
                error: null
            }
        case DATA_SHIP_DEMOLITION_LIST_GET_F:
            var totaldatashipcmpcount = 0

            if (action.payload.content === undefined || '') {
                totaldatashipcmpcount = 0
            }
            else {
                action.payload.content.map((data: any) => {
                    totaldatashipcmpcount = data.total_row
                })
            }
            return {
                ...state,
                isLoading: false,
                dataLasticDemolition: action.payload.content,
                totalPage: action.payload.total_page,
                totalElement: totaldatashipcmpcount
            }
        case DATA_SHIP_DEMOLITION_LIST_GET_R:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case DATA_SHIP_DEMOLITION_SELECTED_SET:
            return {
                ...state,
                dataLasticSelectedDemolition: action.payload
            }
        default:
            return state
    }
}